import styled from 'styled-components';

import { JSX } from 'react';
import ooeConstants from '../../constants';

interface NavigationProps {
  className?: string;
  leftDesktop?: JSX.Element;
  leftMobile?: JSX.Element;
  rightDesktop?: JSX.Element;
  rightMobile?: JSX.Element;
  pathname?: string;
  children: React.ReactNode;
}

export const NavigationComponent: React.FC<NavigationProps> = ({
  className,
  children,
  leftMobile,
  leftDesktop,
  rightMobile,
  rightDesktop,
  pathname = '/',
}) => {
  const title = ooeConstants.GET_TITLE[pathname as keyof typeof ooeConstants.GET_TITLE];
  return (
    <div className={className}>
      <div className="mobile-header">
        <div style={{ width: '20%' }}>{leftMobile}</div>
        <div>
          <h2 className="title">{title}</h2>
        </div>
        <div style={{ width: '20%' }}>{rightMobile}</div>
      </div>
      <div className="desktop-navigation">
        <div>{leftDesktop}</div>
        <div className="desktop-center">{children}</div>
        <div className="desktop-right">{rightDesktop}</div>
      </div>
      <div className="mobile-navigation">{children}</div>
    </div>
  );
};

const StyledNavigation = styled(NavigationComponent)`
  position: sticky;
  top: 0;
  z-index: 1249;

  & .mobile-header,
  .desktop-navigation,
  .mobile-navigation {
    height: 75px;
    z-index: 1000;
    font-family: ${(props) => props.theme.fontFamily};
    color: ${(props) => props.theme.colors.primary};
    background-color: ${(props) => props.theme.colors.background};
    width: 100%;
  }

  & .mobile-header {
    display: none;

    @media (max-width: ${(props) => props.theme.phone}) {
      & .title {
        font-size: 19px;
        margin-top: 0;
        color: ${(props) => props.theme.colors.text};
      }

      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  & .mobile-navigation {
    display: none;

    @media (max-width: ${(props) => props.theme.phone}) {
      display: block;
      position: fixed;
      left: 0;
      bottom: 0;
      padding-bottom: env(safe-area-inset-bottom);
    }
  }

  & .desktop-navigation {
    display: flex;
    align-items: center;

    @media (max-width: ${(props) => props.theme.phone}) {
      display: none;
    }
  }

  & .desktop-right {
    text-align: right;
    flex: 2;
    width: 50%;
  }

  & .desktop-center {
    flex: 3;
    height: 100%;
  }

  & svg {
    fill: ${(props) => props.theme.colors.primary};
  }

  & svg:hover {
    fill: ${(props) => props.theme.colors.primary};
  }
`;

export default StyledNavigation;
